import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55f5578b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "test-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "complete-title" }, "回答が完了しました", -1))
const _hoisted_3 = { class: "page-caption" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "txt" }, "下記の通り回答いたしました。ご協力ありがとうございました。", -1))
const _hoisted_5 = { class: "flex no-wrap justify-between q-gutter-sm" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任意のメールに回答結果を送る", -1))
const _hoisted_7 = { class: "complete-heading" }
const _hoisted_8 = { class: "page-wrap" }
const _hoisted_9 = { class: "bg-gray" }
const _hoisted_10 = { class: "page-wrap" }
const _hoisted_11 = { class: "text-center q-mt-md" }

import { ref, computed } from 'vue'
import api from '@/api'
import { useAsyncTask } from 'vue-concurrency'
import { ResultCard } from '@/components'
import { useRoute } from 'vue-router'
import { swalError, isDev } from '@/utils'
import { Book, Sheet } from '@/models'

// TODO: 同じAPIが2回呼ばれているので修正必須


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

/** Sheetの固有ID */
const sheetHash = computed(() => route.query.cd as string)

const book = ref(new Book())

/* Sheetデータ */
const sheet = ref(
  new Sheet({
    sheetHash: sheetHash.value,
  }),
)

const task = useAsyncTask(async () => {
  return api.sheet
    .getAnswer({ cd: sheetHash.value })
    .then(data => {
      // Bookデータを保持
      book.value = data.book

      // Sheetデータを構築
      sheet.value = data.sheet
    })
    .catch(err => {
      swalError.fire({ text: err ?? '送信できませんでした' })
    })
})

task.perform()

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_q_btn, {
          to: { path: '/sheet', query: { cd: book.value.sheetHash } },
          size: "md",
          label: "もう一度回答する",
          color: "secondary",
          class: "text-no-wrap"
        }, null, 8, ["to"]),
        _createVNode(_component_q_btn, {
          size: "md",
          type: "a",
          color: "secondary",
          href: `mailto:?subject=${book.value.bookName}の回答結果&body=%0D%0A下記のURLから回答結果をご覧ください。%0D%0A${book.value.url.answer}${_unref(route).query.cd}%0D%0A`
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["href"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(book.value.bookName) + "の回答結果", 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_unref(ResultCard), { "answer-hash": _unref(sheetHash) }, null, 8, ["answer-hash"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_q_btn, _mergeProps({
        unelevated: "",
        color: "primary",
        label: "プレチェクトップへ"
      }, _unref(isDev) ? { to: '/' } : { type: 'a', href: '/' }, { style: {"max-width":"357px","width":"100%","height":"46px"} }), null, 16)
    ])
  ]))
}
}

})